import { distanceInWords, parseDateTime } from 'src/utils/date'
import { date } from 'quasar'
import { formatMoney } from 'src/utils/format'
import { getCustomerName } from 'src/utils/searchResultParser'
import { getStatusText } from 'components/Invoices/Utils'
import i18n from 'src/i18n/i18n'
import { invoices as invoicesConfig } from 'src/config'

const defaultColumns = [
  { name: 'invoice_number', required: true, label: i18n.t('invoice_number'), align: 'left', field: 'invoice_number', sortable: true },
  { name: 'customer_name', required: true, label: i18n.tc('customer', 1), align: 'left', field: 'customer_name' },
  { name: 'total_gross', required: true, label: i18n.t('sum_gross'), align: 'left', field: 'total_gross' },
  { name: 'created_at', required: true, label: i18n.t('created_at'), align: 'left', field: 'created_at_text', sortable: true },
  { name: 'status', required: true, label: i18n.t('status'), align: 'left', field: 'status' },
  { name: 'due_in', required: true, label: i18n.t('due_date'), align: 'left', field: 'due_in' },
  { name: 'actions', required: false, label: '', align: 'right', field: 'invoice_number' }
]

const defaultMapFunction = invoices => {
  return invoices.map(invoice => {
    return {
      ...invoice,
      'customer_name': getCustomerName(invoice.customer.data),
      'total_gross': formatMoney(invoice.total_gross, invoice.currency),
      'invoice_date': date.formatDate(parseDateTime(invoice.invoice_date.date), i18n.t('date_format')),
      'status': { value: invoice.status, color: invoicesConfig.status_colors[invoice.status] },
      'committed_at': invoice.committed_at ? invoice.committed_at.date : null,
      'due_in': getStatusText(invoice),
      'created_at_text': distanceInWords(invoice.created_at.date),
      'created_at_date': date.formatDate(parseDateTime(invoice.created_at.date), i18n.t('date_time_format'))
    }
  })
}

export { defaultMapFunction, defaultColumns }
